<template>
  <div class="login-panel-impl" v-loading="loginProcess">
    <div class="line"></div>
    <div class="title-area">
      Amazon4Sellers
    </div>
    <div class="login-form">
      <v-text-field
        v-model="loginForm.userName"
        label="账号"
        required/>
      <v-text-field
        v-model="loginForm.password"
        label="密码"
        type="password"
        required/>
      <v-switch
        v-model="loginForm.rememberPassword"
        label="记住密码"
        color="primary"/>
      <v-btn color="primary" class="login-button" large @click="login">登录</v-btn>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import LoginService from '@/service/user/LoginService'
import AppInfoDefine from '@/define/info/AppInfo'

@Component
export default class LoginPanel extends Vue {
  lang = 'user.login_panel.'
  loginForm = LoginService.getLoginFormCache()
  loginProcess = false

  login () {
    this.loginProcess = true
    LoginService.login(this.loginForm).then(() => {
      this.$notify.success({
        title: '登录成功',
        message: '欢迎来到' + AppInfoDefine.APP_NAME
      })
      this.loginProcess = false
    }).catch((e) => {
      this.loginProcess = false
      this.$alert('登录失败 ' + e.response.data.errMsg, '登录', {
        confirmButtonText: '确定'
      })
    })
  }
}
</script>

<style scoped lang="scss">
  .login-panel-impl {
    background: #ffffff;
    box-shadow: 2px 2px 15px #111111;
    display: flex;
    flex-direction: column;
    text-align: center;

    .logo {
      width: 150px;
      margin-top: 20px;
    }

    .title-area{
      font-size: 40px;
      margin: 40px 0;
    }

    .line {
      height: 6px;
      background: #e65698;
      background: -webkit-linear-gradient(to right, #e65698, #218ece);
      background: linear-gradient(to right, #e65698, #218ece);
    }

    .login-form {
      flex-grow: 1;
      padding: 10px 40px;
    }

    .login-button {
      margin-top: 10px;
      width: 300px;
    }
  }
</style>
